<template>
  <div class="flex justify-center" v-if="isLoaded">
    <div
      class="rounded-full px-3 py-1 border border-action hover:bg-menu-hover m-1 cursor-pointer relative"
      @click="selectRelease(release)"
      v-for="release in releases"
      :key="release.id"
      :data="release"
    >
      <span v-text="release.version" />
      <small
        v-if="release.status != 'production'"
        class="text-gray-800 pl-2"
        v-text="release.status"
      />
    </div>
  </div>
</template>

<script>
import { handleAxiosError } from "@/boot/functions";

import useSWRV from "@/store/swrv";
import { watch } from "@vue/composition-api";
export default {
  props: ["slug"],
  setup(props) {
    const { data, error, isLoaded } = useSWRV(
      "/api/app/applications/" + props.slug + "/releases"
    );

    watch(error, handleAxiosError);
    return { releases: data, isLoaded };
  },
  methods: {
    selectRelease(release) {
      this.$emit("release-selected", release);
    },
  },
};
</script>
